/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierClaimNotice } from "./CarrierClaimNotice";
import {
  CarrierClaimNoticeFromJSON,
  CarrierClaimNoticeFromJSONTyped,
  CarrierClaimNoticeToJSON,
  CarrierClaimNoticeToJSONTyped,
} from "./CarrierClaimNotice";
import type { Company } from "./Company";
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  CompanyToJSONTyped,
} from "./Company";
import type { FreightClaim } from "./FreightClaim";
import {
  FreightClaimFromJSON,
  FreightClaimFromJSONTyped,
  FreightClaimToJSON,
  FreightClaimToJSONTyped,
} from "./FreightClaim";
import type { Shipment } from "./Shipment";
import {
  ShipmentFromJSON,
  ShipmentFromJSONTyped,
  ShipmentToJSON,
  ShipmentToJSONTyped,
} from "./Shipment";

/**
 *
 * @export
 * @interface ShipmentCompanyFreightClaim
 */
export interface ShipmentCompanyFreightClaim {
  /**
   *
   * @type {Shipment}
   * @memberof ShipmentCompanyFreightClaim
   */
  shipment: Shipment;
  /**
   *
   * @type {Company}
   * @memberof ShipmentCompanyFreightClaim
   */
  company: Company;
  /**
   *
   * @type {FreightClaim}
   * @memberof ShipmentCompanyFreightClaim
   */
  freightClaim: FreightClaim;
  /**
   *
   * @type {CarrierClaimNotice}
   * @memberof ShipmentCompanyFreightClaim
   */
  carrierClaimNotice?: CarrierClaimNotice | null;
}

/**
 * Check if a given object implements the ShipmentCompanyFreightClaim interface.
 */
export function instanceOfShipmentCompanyFreightClaim(
  value: object,
): value is ShipmentCompanyFreightClaim {
  if (!("shipment" in value) || value["shipment"] === undefined) return false;
  if (!("company" in value) || value["company"] === undefined) return false;
  if (!("freightClaim" in value) || value["freightClaim"] === undefined)
    return false;
  return true;
}

export function ShipmentCompanyFreightClaimFromJSON(
  json: any,
): ShipmentCompanyFreightClaim {
  return ShipmentCompanyFreightClaimFromJSONTyped(json, false);
}

export function ShipmentCompanyFreightClaimFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentCompanyFreightClaim {
  if (json == null) {
    return json;
  }
  return {
    shipment: ShipmentFromJSON(json["shipment"]),
    company: CompanyFromJSON(json["company"]),
    freightClaim: FreightClaimFromJSON(json["freightClaim"]),
    carrierClaimNotice:
      json["carrierClaimNotice"] == null
        ? undefined
        : CarrierClaimNoticeFromJSON(json["carrierClaimNotice"]),
  };
}

export function ShipmentCompanyFreightClaimToJSON(
  json: any,
): ShipmentCompanyFreightClaim {
  return ShipmentCompanyFreightClaimToJSONTyped(json, false);
}

export function ShipmentCompanyFreightClaimToJSONTyped(
  value?: ShipmentCompanyFreightClaim | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipment: ShipmentToJSON(value["shipment"]),
    company: CompanyToJSON(value["company"]),
    freightClaim: FreightClaimToJSON(value["freightClaim"]),
    carrierClaimNotice: CarrierClaimNoticeToJSON(value["carrierClaimNotice"]),
  };
}
